import React from "react";

function Pagination({ currentPage, totalItems, itemsPerPage, onPageChange, onItemsPerPageChange }) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center flex-wrap p-3 shadow-sm rounded bg-white border gap-3">
                <div className="d-flex align-items-center mt-2 mt-md-0">
                    <button
                        className="btn btn-sm btn-outline-primary me-2"
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                    >
                        ⬅️ Précédent
                    </button>

                    <span className="mx-2 fw-semibold">
                        Page <span className="text-primary">{currentPage}</span> / {totalPages}
                    </span>

                    <button
                        className="btn btn-sm btn-outline-primary ms-2"
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                    >
                        Suivant ➡️
                    </button>
                </div>
                <div className="content-nbr-page d-flex align-items-center ml-4 justify-content-center">
                <label htmlFor="itemsPerPage" className="fw-bold text-primary" style={{marginBottom:'0'}}>
                    Images par page :
                </label>
                <select
                    id="itemsPerPage"
                    className="form-control form-select-sm w-auto"
                    value={itemsPerPage}
                    onChange={(e) => {
                        onItemsPerPageChange(parseInt(e.target.value));
                        onPageChange(1);
                    }}
                    style={{width:"70px", marginLeft:"5px", height:"30px"}}
                >
                    {[5, 10, 20, 50, 100, 150, 200].map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </div>
            </div>            
        </>
    );
}

export default Pagination;
